import { StatesInOffersSource } from "@/DTOs/Enums/StatesInOffersSource"
import { LanguageType } from "@/i18n/languageTypes"
import { IOfferState } from "@/store/Interfaces/Offer/IOfferState"
import { FeatureToggleConfig } from "@/config/featureToggleConfiguration"
import { ApplicationName } from "@/config/applicationNames"
import EkompletConfig from "@/config/featureToggleConfiguration.Ekomplet.json"
import SemaConfig from "@/config/featureToggleConfiguration.Sema.json"

const configMap: Partial<Record<string, FeatureToggleConfig>> = {
  [ApplicationName.Ekomplet]: EkompletConfig,
  [ApplicationName.Sema]: SemaConfig,
}

const defaultConfig: FeatureToggleConfig = configMap[process.env.VUE_APP_APPLICATION_NAME ?? ''] ?? EkompletConfig
const defaultLanguage = (defaultConfig.defaultLanguage as LanguageType | undefined) ?? LanguageType.DK

export const state: IOfferState = {
  CurrentOffer: {
    ID: 0,
    MostRecentAcceptedOrDeclinedStateId: 0,
    PublicIdentifier: "",
    StateId: 0,
    OfferNumber: undefined,
    ValidUntilDate: ""
  },

  OfferDepartment: {
    Address: "",
    CVRNumber: "",
    City: "",
    DepartmentName: "",
    Email: "",
    LogoAsBase64: "",
    Phone: "",
    Zip: ""
  },

  PDF: new Uint8Array,
  PDFName: '',
  PdfScale: 1,
  CurrentPdfPageNumber: 0,
  TotalNumberOfPdfPages: 0,
  PdfIsFullScreen: false,
  PdfPageWasChangedManually: false,
  SiteInitializationComplete: false,
  OfferAccepted: false,
  OfferRejected: false,
  Language: defaultLanguage,
  SiteOpenedWith: StatesInOffersSource.Portal,
  Config: defaultConfig
}